import React from 'react';
export function UnifiedTestimonialsSection() {
  const videoTestimonials = [{
    name: 'Dave',
    result: 'Resultados Mensuales Extraordinarios',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oAUbG8UT5KHGgYpUNbQUXL/Screenshot_2025-11-02_at_1.35.27_PM.png'
  }, {
    name: 'Rafel',
    result: 'Transformación en 60 Días',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aCDGRQQCX9URTtyN3xLx6F/Screenshot_2025-11-02_at_1.35.36_PM.png'
  }, {
    name: 'Parker',
    result: 'Éxito en 5 Semanas',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/j5ad9VgTKQ6c1mVZr2hQu2/Screenshot_2025-11-02_at_1.35.46_PM.png'
  }];
  const chatTestimonials = [{
    name: 'Chris',
    result: 'Resultados Extraordinarios',
    detail: 'Y ni siquiera tenía todo listo',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/svykPXNMKepQekY5QzTx5B/Screenshot_2025-11-02_at_1.06.00_PM.png'
  }, {
    name: 'David',
    result: 'Consistencia Semanal',
    detail: 'Resultados que cambian vidas',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sYimhaXDdvXynszhjEbuQU/Screenshot_2025-11-02_at_1.06.14_PM.png'
  }, {
    name: 'Joe',
    result: 'Transformación Rápida',
    detail: 'Resultados verificables',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eVxWGbCFLN1NsKDMYnhC57/Screenshot_2025-11-02_at_1.10.20_PM.png'
  }, {
    name: 'Parker',
    result: 'Éxito Acelerado',
    detail: 'Resultados que inspiran',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xrpBDV1GWncRepVsukiUBM/Screenshot_2025-11-02_at_1.06.40_PM.png'
  }];
  return <section className="w-full bg-gradient-to-b from-[#1C1C1C] to-[#0D0D0D] py-12 md:py-24 px-4 md:px-6" data-id="element-188">
      <div className="max-w-7xl mx-auto" data-id="element-189">
        <div className="text-center mb-8 md:mb-16" data-id="element-190">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-4" data-id="element-191">
            Personas Reales con{' '}
            <span className="text-[#FF4F75]" data-id="element-192">Resultados Comprobados</span>
          </h2>
          <div className="w-24 md:w-32 h-1 bg-gradient-to-r from-[#FF4F75] to-[#D4AF37] mx-auto my-4 md:my-8" data-id="element-193"></div>
          <p className="font-['Inter'] text-sm md:text-xl text-gray-300 max-w-3xl mx-auto px-4" data-id="element-194">
            Testimonios reales de estudiantes certificados
          </p>
        </div>
        {/* Video Testimonials - Top Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-6 md:mb-12" data-id="element-195">
          {videoTestimonials.map((testimonial, index) => <div key={index} className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0D0D0D] to-[#1C1C1C] border border-[#FF4F75]/20 hover:border-[#FF4F75]/50 transition-all duration-300 hover:scale-105" data-id="element-196">
              <div className="aspect-video relative" data-id="element-197">
                <img src={testimonial.image} alt={`${testimonial.name} - Testimonio`} className="w-full h-full object-cover" data-id="element-198" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent" data-id="element-199"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-6" data-id="element-200">
                  <h3 className="font-['Playfair_Display'] text-lg md:text-2xl font-bold text-white mb-1 md:mb-2" data-id="element-201">
                    {testimonial.name}
                  </h3>
                  <p className="font-['Inter'] text-[#FF4F75] font-semibold text-xs md:text-base" data-id="element-202">
                    {testimonial.result}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
        {/* Chat Testimonials - Bottom Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8" data-id="element-203">
          {chatTestimonials.map((testimonial, index) => <div key={index} className="group relative overflow-hidden rounded-xl md:rounded-2xl bg-gradient-to-br from-[#0D0D0D] to-[#1C1C1C] border border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-all duration-300 hover:scale-105" data-id="element-204">
              <div className="aspect-[9/16] relative" data-id="element-205">
                <img src={testimonial.image} alt={`${testimonial.name} - Testimonio`} className="w-full h-full object-cover" data-id="element-206" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent" data-id="element-207"></div>
                <div className="absolute bottom-0 left-0 right-0 p-2 md:p-6" data-id="element-208">
                  <h3 className="font-['Playfair_Display'] text-sm md:text-2xl font-bold text-white mb-0.5 md:mb-2" data-id="element-209">
                    {testimonial.name}
                  </h3>
                  <p className="text-[#D4AF37] font-bold text-xs md:text-xl mb-0.5 md:mb-1" data-id="element-210">
                    {testimonial.result}
                  </p>
                  <p className="font-['Inter'] text-gray-300 text-[10px] md:text-sm" data-id="element-211">
                    {testimonial.detail}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-6 md:mt-12" data-id="element-212">
          <p className="font-['Inter'] text-xs md:text-base text-gray-400 italic max-w-3xl mx-auto px-4" data-id="element-213">
            Testimonios reales de estudiantes certificados. Los resultados
            pueden variar según dedicación y esfuerzo.
          </p>
        </div>
      </div>
    </section>;
}